import { supabase } from '../supabase/supabase';

export const fetchAdminOverviewMetrics = async () => {
  const { data, error } = await supabase.rpc(
    'admin_get_overview_metrics_1793058000000'
  );

  if (error) throw error;

  return Array.isArray(data) ? data[0] || null : data;
};
